import Vue from 'vue'
import axios from 'axios'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'open-iconic/font/css/open-iconic-bootstrap.min.css'


const App = (
  RootComponent,
  props = (app => ({})),
) => {
  const axiosInstance = axios.create({
    baseURL: '/hooks/internal-api/',
  })
  axiosInstance.defaults.headers.common.Authorization =
    window.ITS_PAGE_DATA.authHeader
  Vue.prototype.$axios = axiosInstance

  return new Vue({
    el: '#app',
    data: window.ITS_PAGE_DATA,
    render(createElement) {
      return createElement(RootComponent, { props: props(this) })
    },
  })
}

export default (...args) => {
  window.app = App(...args)
}
